export default __webpack_public_path__ + "static/media/twitter-logo-old.60c54b70.svg";